<div class="d-flex flex-column min-vh-100 justify-content-between">

<app-header-emvs *appReloadDirective="reloadHeader" ></app-header-emvs>

<router-outlet></router-outlet>
<div *ngIf="this.location.path() == ''">
    <app-inicio></app-inicio>
</div>

<app-footer-emvs ></app-footer-emvs>

</div>
